const config = {
    api_location: process.env.API_LOCATION ? process.env.API_LOCATION : "https://react-video-meeting-server-production.up.railway.app",
};

export default config;